// src/context/SelectionContext.jsx
import React, { createContext, useContext, useState, useMemo } from 'react';

const SelectionContext = createContext();

export const SelectionProvider = ({ children, messages = [] }) => {
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState(new Set());
  const [selectableAIMessages, setSelectableAIMessages] = useState([]);
  // Compute selectableAIMessages with useMemo to avoid unnecessary updates
  // const selectableAIMessages = useMemo(() => {
  //   const aiMessages = messages.filter(
  //     (msg) => !msg.isUser && msg.content && msg.content.trim() !== ''
  //   );
  //   console.log('SelectionProvider: Computed selectableAIMessages, length:', aiMessages.length);
  //   return aiMessages;
  // }, [messages]);

  const handleSelectAll = () => {
    const allAIMessageIds = selectableAIMessages.map((msg) => msg.run_id);
    console.log('Selecting all AI messages:', allAIMessageIds);
    setSelectedMessages(new Set(allAIMessageIds));
  };

  const handleDeselectAll = () => {
    console.log('Deselecting all messages');
    setSelectedMessages(new Set());
    // setIsSelectionMode(false)
  };
  const handleResetSelection = () => {
    console.log('resetting selected and mode state');
    setSelectedMessages(new Set());
    setIsSelectionMode(false)
  };

  return (
    <SelectionContext.Provider
      value={{
        isSelectionMode,
        setIsSelectionMode,
        selectedMessages,
        setSelectedMessages,
        selectableAIMessages,
        handleSelectAll,
        handleDeselectAll,
        setSelectableAIMessages,
        handleResetSelection
      }}
    >
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelection = () => useContext(SelectionContext);